import { useList } from '@refinedev/core';
import { PricingTiersSection } from '@/components/pricing-tiers';
import type { TranslationLanguage } from '@/components/translations';

interface LanguageRecord {
  code: string;
  name: string;
  nativeName: string;
  flag?: string | null;
  flagEmoji?: string | null;
}

interface CoursePricingTabProps {
  courseId: string | number;
}

export function CoursePricingTab({ courseId }: CoursePricingTabProps) {
  const { result: langResult } = useList<LanguageRecord>({ resource: 'languages' });
  const languages: TranslationLanguage[] = (langResult?.data ?? []).map((l) => ({
    code: l.code,
    name: l.name,
    nativeName: l.nativeName,
    flag: l.flag ?? l.flagEmoji ?? '🏳️',
  }));

  return (
    <div className="space-y-4 pt-6">
      <PricingTiersSection
        productKey={{ courseId: Number(courseId) }}
        languages={languages}
      />
    </div>
  );
}
